export const GET_KEYWORDS_DAILY_STATS_FOR_PROJECT = 'get-keywords-daily-stats-for-project';
